import { useMemo } from "react";

export const useSelectFilter = ({ value, categoryName, onChange }) => {
  const selectId = useMemo(
    () => `SelectFilter-${categoryName}`,
    [categoryName],
  );

  const selectedValues = useMemo(() => {
    if (Array.isArray(value)) {
      return new Set(value);
    }
    if (!value) {
      return new Set();
    }
    return new Set([value]);
  }, [value]);

  const handleToggle = (itemValue) => {
    const next = new Set(selectedValues);
    if (next.has(itemValue)) {
      next.delete(itemValue);
    } else {
      next.add(itemValue);
    }
    const nextArray = Array.from(next);
    onChange(null, categoryName, nextArray);
  };

  return { selectId, selectedValues, handleToggle };
};
